import { post, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'


async function getTransferAnalysis(){


  const payload={
    apiName: 'LivisiblyTransferAnalysisApi',
    path: 'transfers/sankey'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;
  const result=processResponse(response)
  // console.log(`Result: ${JSON.stringify(result)})`);
  return result
}


export function useGetTransferAnalysis(shouldFetch=true){
  const result = useSWR(
    shouldFetch ? 'TRANSFER_ANALYSIS' : null,
    (path) => getTransferAnalysis()
  );
  return result;
}

